import { css } from 'styled-components'
import { COLORS } from '~/shared/constants/uiConstants'

export const communicationRootCss = css`
  width: 100%;
  height: calc(100dvh - var(--header-height));
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.WHITE};
  overflow-y: auto;
`

export const communicationContentWrapperCss = css`
  width: 100%;
  max-width: 375px;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 16px;
`

export const communicationTitleGroupCss = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const communicationTitleCss = css`
  font-family: 'Poppins', sans-serif;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  color: ${COLORS.BLACK};
`

export const communicationSubtitleCss = css`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
  color: #17202a;
`

export const communicationImageWrapperCss = css`
  width: 100%;

  picture {
    display: block;
    width: 100%;
  }

  img {
    display: block;
    width: 100%;
    max-width: 100%;
  }
`

export const communicationOptionEmojiCss = css`
  font-size: 22px;
  line-height: 1;
`

export const communicationOptionLabelCss = css`
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3;
  color: ${COLORS.BLACK};
`

export const communicationButtonCss = css`
  width: 100%;
  padding: 18px 16px;
  background-color: #096ef9;
  border: none;
  border-radius: 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: ${COLORS.WHITE};
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`
